import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "katia-cookie-consent-v1";
const GA_ID = process.env.REACT_APP_GA4_ID; // e.g., G-XXXXXXXXXX

function loadGA() {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export default function CookieBanner() {
  const [choice, setChoice] = useState(null);
  useEffect(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v) {
      setChoice(v);
      if (v === "accepted") loadGA();
    }
  }, []);
  if (choice) return null;

  const decide = (val) => {
    localStorage.setItem(STORAGE_KEY, val);
    setChoice(val);
    if (val === "accepted") loadGA();
  };

  return (
    <div
      role="dialog"
      aria-label="Consentimiento de cookies"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-xl rounded-2xl border border-[hsl(var(--clinic-border))] bg-white p-5 shadow-2xl md:left-6 md:right-auto"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-display text-lg font-semibold">Cookies</div>
          <p className="mt-1 text-sm text-[hsl(var(--clinic-muted))]">
            Usamos cookies técnicas necesarias y, con tu permiso, analíticas (Google Analytics 4) para mejorar el sitio.
            Puedes rechazarlas y seguir navegando.
          </p>
        </div>
        <button onClick={() => decide("rejected")} aria-label="Rechazar" data-testid="cookie-close">
          <X size={18} />
        </button>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => decide("accepted")}
          className="rounded-full bg-[hsl(var(--clinic-text))] px-4 py-2 text-sm font-semibold text-white"
        >
          Aceptar todo
        </button>
        <button
          data-testid="cookie-reject"
          onClick={() => decide("rejected")}
          className="rounded-full border border-[hsl(var(--clinic-border))] px-4 py-2 text-sm font-semibold"
        >
          Solo necesarias
        </button>
        <a href="/legal" className="ml-auto self-center text-xs underline">
          Más información
        </a>
      </div>
    </div>
  );
}
